/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Rating_ReviewsInputs */

const en_funnel_sq_rating_reviews = /** @type {(inputs: Funnel_Sq_Rating_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`from 12,000+ reviews`)
};

const es_funnel_sq_rating_reviews = /** @type {(inputs: Funnel_Sq_Rating_ReviewsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`de más de 12.000 reseñas`)
};

/**
* | output |
* | --- |
* | "from 12,000+ reviews" |
*
* @param {Funnel_Sq_Rating_ReviewsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_rating_reviews = /** @type {((inputs?: Funnel_Sq_Rating_ReviewsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Rating_ReviewsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_rating_reviews(inputs)
	return en_funnel_sq_rating_reviews(inputs)
});